import { render, staticRenderFns } from "./CreatorVideoShareDialog.vue?vue&type=template&id=1b632376&"
import script from "./CreatorVideoShareDialog.vue?vue&type=script&lang=js&"
export * from "./CreatorVideoShareDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports